import BaseListPresenter from "../../../base/BaseListPresenter";
import { formatDate } from "../../../components/common/Converter";

class PerformancePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    const getcurrent = this.view.getcurrent();
    this.limit = 10;
    this.where = {
      supervisor: getcurrent,
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  handleObjectChange = (hierarchy) => {
    console.log("hierarchy: ", hierarchy);
    const filteredObject = Object.fromEntries(
      Object.entries(hierarchy).filter(([_, value]) => value) // Keep entries with truthy values
    );
    this.filterSubmit({ employee: { ...filteredObject } });
  };

  generateCSV(objects) {
    const headers = [
      "Performance Type",
      "Employee",
      "Period From",
      "Period To",
      "Date Created",
      "Status",
      "Assigned Employee",
      "Total Rating",
      "Final Average Rating",
    ];

    const rows = this.objects.map((object) => [
      object?.type ?? "",
      `${object?.employee?.Firstname || ""} ${
        object?.employee?.Middlename || ""
      } ${object?.employee?.surname || ""}` ?? "",
      `"${formatDate(object?.periodFrom) ?? ""}"`,
      `"${formatDate(object?.periodTo) ?? ""}"`,
      `"${formatDate(object?.createdAt) ?? ""}"`,
      object?.stats ?? "",
      `${object?.assignedEmployee?.Firstname || ""} ${
        object?.assignedEmployee?.Middlename || ""
      } ${object?.assignedEmployee?.surname || ""}` ?? "",
      object?.performance.reduce(
        (sum, item) => sum + parseFloat(item.averagedeci),
        0
      ) ?? "",
      object?.performance.reduce(
        (sum, item) => sum + parseFloat(item.averagedeci),
        0
      ) ?? "",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Performance.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
export default PerformancePresenter;
